import decodePayload from '@utils/jwt/decodePayload'

const checkIfExpired = (token, decodedPayload) => {
    const payload = decodedPayload || decodePayload(token)
    return !payload || payload.expires < Date.now() // expired
}

export default checkIfExpired